import { Action } from '@anm/components/ActionsDropdown';
import { getDropdownAction, getDropdownActions, ActionsHandlers } from '@anm/helpers/dropdownActions';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';

import useDuplicateAction from '../../ProjectPlayerBlock/hooks/useDuplicateAction';

type ProjectDropdownActionsProps = Partial<ActionsHandlers> & {
  renderEditLink: (children: JSX.Element) => JSX.Element;
};
const useImageProjectDropdownActions = ({
  onMove,
  onDelete,
  onDownload,
  onDuplicate,
  renderEditLink
}: ProjectDropdownActionsProps) => {
  const editAction: Action = {
    ...getDropdownAction('onEditImage'),
    renderLink: renderEditLink
  };

  const duplicateAction = useDuplicateAction({ handler: onDuplicate });

  return [
    !isMobileOrIPad() && editAction,
    duplicateAction,
    ...getDropdownActions({
      ...(onDownload && { onDownload }),
      ...(onMove && { onMove }),
      ...(onDelete && { onDelete })
    })
  ].filter(Boolean) as Action[];
};

export default useImageProjectDropdownActions;
